import { AMULET, CRYSTAL, QUEENSFIRE, FOREST_BOW } from 'helpers/constants';

export const itemIDsBySpriteIndex = {
  [AMULET]: 7,
  [QUEENSFIRE]: 4,
  [FOREST_BOW]: 5,
  [CRYSTAL]: 1
};

export const itemMetaBySpriteIndex = {
  [AMULET]: { id: 7, class: 'fayette' },
  [QUEENSFIRE]: { id: 4, class: 'queen' },
  [FOREST_BOW]: { id: 5, class: 'any' },
  [CRYSTAL]: { id: 1, class: 'any' }
};
